export default __webpack_public_path__ + "static/media/pantheon.e70d0d1b.svg";